// i18n init (side-effect) + bundled Arabic font MUST load before the App and
// globals.css so the first render resolves `t()` and the Naskh face is ready
// (W8 — i18n bundled, no BE fetch). Do NOT reorder below the App import.
import '@/lib/i18n'
// Feature barrel (side-effect): each wave-1/2 feature's register.ts populates
// the tab registry here BEFORE createRoot — static imports run synchronously at
// module-eval, so the registry is ready before React mounts (plan §2.2). Empty
// at F-SHELL merge (no feature registered yet).
import '@/ui/features'
import '@fontsource/noto-naskh-arabic'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './ui/App'
import { waitForOffice } from './office-init'
import './ui/styles/globals.css'

// Wait for Office.onReady (no-op in browser preview) before mounting the
// React tree. This is the only Office.js call in the mockup phase.
async function bootstrap(): Promise<void> {
  const host = await waitForOffice()
  // eslint-disable-next-line no-console
  console.info('[theplaidoyer-addin] host detected:', host)

  const rootElement = document.getElementById('root')
  if (!rootElement) {
    throw new Error('Root element #root not found')
  }

  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
